import {
  FETCH_CONVERSATION,
  FETCH_MESSAGE_LIST,
  FETCH_MORE_MESSAGE,
  UPDATE_TO_READ,
  CHANGE_RECIPIENT,
  UPDATE_CHAT,
  UPDATE_MEDIA_LAYOUT,
} from "./types";
import { baseUrl, headersJson } from "../../auth/secret";
import { USER } from "../../constants/app";

export const fetch_conversation = (payload) => (dispatch) => {
  fetch(`${baseUrl}/public/chat-message/history-list/${USER}`, {
    method: "POST",
    headers: headersJson(),
    body: JSON.stringify(payload),
  })
    .then((response) => response.json())
    .then((data) => {
      let conversations = data.body.map((conversation) => {
        return {
          id: conversation.id,
          sender: conversation.sender,
          fullName: conversation.fullName,
          content: conversation.content,
          contentType: conversation.contentType,
          isUnread: conversation.isUnread,
          timestamp: conversation.timestamp,
        };
      });
      dispatch({
        type: FETCH_CONVERSATION,
        payload: {
          conversations,
        },
      });
    })
    .catch((e) => console.log(e));
};

export const fetch_message_list = (payload, callback) => (dispatch) => {
  fetch(
    `${baseUrl}/public/chat-message/list-by-sender-and-recipient/${USER}/${payload.recipient}`,
    {
      method: "POST",
      headers: headersJson(),
      body: JSON.stringify(payload.page),
    }
  )
    .then((resp) => resp.json())
    .then((response) => {
      let messages = [],
        sharedPhotos = [];

      response.body.reverse().forEach((result) => {
        let i = 0;
        if (result.type === "CHAT")
          messages.push({
            id: result.id,
            sender: result.sender,
            contentType: result.contentType,
            content: result.content,
            timestamp: new Date(result.created).getTime(),
            index: result.contentType === "IMAGE" ? i++ : (i += 0),
          });
        if (result.contentType === "IMAGE") {
          sharedPhotos.push({
            original: `${baseUrl}${result.content}`,
            thumbnail: `${baseUrl}${result.content}`,
          });
        }
      });
      callback(true);
      dispatch({
        type: FETCH_MESSAGE_LIST,
        payload: {
          messages,
          sharedPhotos: sharedPhotos.reverse(),
        },
      });
    })
    .catch((error) => console.log(error));
};

export const fetch_more_message = (payload) => (dispatch) => {
  fetch(
    `${baseUrl}/public/chat-message/list-by-sender-and-recipient/${USER}/${payload.recipient}`,
    {
      method: "POST",
      headers: headersJson(),
      body: JSON.stringify(payload.page),
    }
  )
    .then((resp) => resp.json())
    .then((response) => {
      let messages = [],
        sharedPhotos = [];

      response.body.reverse().forEach((result) => {
        if (result.type === "CHAT")
          messages.push({
            id: result.id,
            sender: result.sender,
            contentType: result.contentType,
            content: result.content,
            timestamp: new Date(result.created).getTime(),
          });
        if (result.contentType === "IMAGE") {
          sharedPhotos.push({
            original: `${baseUrl}${result.content}`,
            thumbnail: `${baseUrl}${result.content}`,
          });
        }
      });

      dispatch({
        type: FETCH_MORE_MESSAGE,
        payload: {
          messages,
          sharedPhotos: sharedPhotos.reverse(),
        },
      });
    })
    .catch((error) => console.log(error));
};

export const update_to_read = (payload) => (dispatch) => {
  fetch(
    `${baseUrl}/public/chat-message/update-to-read-all/${payload.recipient}/${USER}`,
    {
      method: "POST",
      headers: headersJson(),
    }
  )
    .then((resp) => resp.json())
    .then((data) => {
      if (data.header.result) {
        dispatch({
          type: UPDATE_TO_READ,
        });
      }
    })
    .catch((error) => console.log(error));
};

export const change_recipient = (payload) => (dispatch) => {
  dispatch({
    type: CHANGE_RECIPIENT,
    payload,
  });
};

export const update_media_layout = () => (dispatch) => {
  dispatch({
    type: UPDATE_MEDIA_LAYOUT,
  });
};

export const update_chat = (payload) => (dispatch) => {
  dispatch({
    type: UPDATE_CHAT,
    payload,
  });
};
